import React from 'react';
import { useTranslation } from 'react-i18next';

import SEO from '../common/SEO';
import HeaderFour from '../common/header/HeaderFour';
import BannerFive from '../component/banner/BannerFive';
import ServicePropOne from '../component/service/ServicePropOne';
import ProcessOne from '../component/process/ProcessOne';
import BrandOne from '../component/brand/BrandOne';
import TestimonialMutawir from '../component/testimonial/TestimonialMutawir';
import BlogOne from '../component/blog/BlogOne';
import ContactSection from '../component/contact/ContactSection';
import FooterOne from '../common/footer/FooterOne';

const CorporateAgency = () => {
  const { t } = useTranslation();
  const services = t('services.items', { returnObjects: true }) || [];

  return (
    <>
      <SEO title={t('meta.homeTitle')} description={t('meta.homeDescription')} />
      <main className="main-wrapper">
        <HeaderFour />
        <BannerFive />
        <section id="services" className="section section-padding bg-color-light mutawir-services">
          <div className="container">
            <div className="row g-5 align-items-start mutawir-section-intro">
              <div className="col-xl-8 col-lg-9">
                <div className="mutawir-section-heading">
                  <span className="mutawir-tagline">{t('services.tagline')}</span>
                  <h2 className="title">{t('services.title')}</h2>
                  <p className="mutawir-section-description">{t('services.description')}</p>
                </div>
              </div>
            </div>
            <div className="row g-4 mt--10">
              <ServicePropOne variant="mutawir" services={services} />
            </div>
          </div>
        </section>
        <ProcessOne variant="timeline" />
        <BrandOne variant="mutawir" />
        <TestimonialMutawir />
        <BlogOne variant="mutawir" />
        <ContactSection />
      </main>
      <FooterOne variant="mutawir" />
    </>
  );
};

export default CorporateAgency;
